"use strict";

angular.module("vendor")
.component("partnershipInline", {
    templateUrl: require("./partnership-inline.component.html"),
    bindings: {
        companyName: "<",
        partnership: "<",
        email: "<",
        usePopover: "<?",
        canEdit: "<?",
        showIcon: "<?"
    },
    controller: function($scope, POPOVER_POPUP_DELAY) {
        $scope.POPOVER_POPUP_DELAY = POPOVER_POPUP_DELAY;

        this.isIncompleteProfile = function() {
            return !!this.partnership && (this.partnership.incomplete_customer || this.partnership.incomplete_user);
        };
    }
});



//////////////////
// WEBPACK FOOTER
// ./vendor/app-core/partnership-inline/partnership-inline.component.js
// module id = 842
// module chunks = 0